var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"id":"StoreView","fluid":"lg"}},[_c('ListStores')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }